var postcss = require('postcss');

var processResult = require('./process-result');
var parse         = require('./parser');

module.exports = function (plugins) {
    var processor = postcss(plugins);
    return function (input) {
        return processor.process(input, { parser: parse }).then(processResult);
    };
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/postcss-js/async.js
 ** module id = 1475
 ** module chunks = 0
 **/